import { create } from 'zustand'

/**
 * How many dialogs are currently open. App chrome that lives in the same shadow-root overlay node
 * (the mobile basket) reads this and simply stops rendering while a dialog is up — reliable
 * regardless of z-index/stacking, which is finicky across Radix's portal wrapper. Counted (not a
 * boolean) so nested/overlapping dialogs behave. `OverlayReporter`, rendered inside each dialog's
 * Content, does the push/pop on mount/unmount.
 */
interface OverlayState {
  count: number
  push: () => void
  pop: () => void
}

export const useOverlayStore = create<OverlayState>((set) => ({
  count: 0,
  push: () => set((s) => ({ count: s.count + 1 })),
  pop: () => set((s) => ({ count: Math.max(0, s.count - 1) })),
}))

export const useAnyOverlayOpen = (): boolean => useOverlayStore((s) => s.count > 0)
